export interface CampoItem {
  key: string;
  label: string;
  isChild?: boolean;
  parentKey?: string;
  childKeys?: string[];
}

export interface CampoState {
  enabled: boolean;
  required: boolean;
}

export const buildInitialState = (items: CampoItem[]): Record<string, CampoState> => {
  const state: Record<string, CampoState> = {};
  items.forEach((item) => { state[item.key] = { enabled: true, required: false }; });
  return state;
};

export const buildDisabledState = (items: CampoItem[]): Record<string, CampoState> => {
  const state: Record<string, CampoState> = {};
  items.forEach((item) => { state[item.key] = { enabled: false, required: false }; });
  return state;
};

// A parent is enabled when at least one child is enabled and becomes required
// automatically only when every child is both enabled and required.
export const normalizeParentsFromChildren = (
  state: Record<string, CampoState>,
  items: CampoItem[],
): Record<string, CampoState> => {
  let changed = false;
  const next = { ...state };
  items.forEach((item) => {
    if (!item.childKeys || item.childKeys.length === 0) return;
    const current = next[item.key];
    if (!current) return;
    const anyChildEnabled = item.childKeys.some((ck) => next[ck]?.enabled === true);
    const allChildrenRequired = item.childKeys.every(
      (ck) => next[ck]?.enabled === true && next[ck]?.required === true,
    );
    const normalized = {
      enabled: anyChildEnabled,
      required: anyChildEnabled && allChildrenRequired,
    };
    if (current.enabled !== normalized.enabled || current.required !== normalized.required) {
      next[item.key] = normalized;
      changed = true;
    }
  });
  return changed ? next : state;
};
